import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useBusinessNamesService from '../../../app/services/hooks/useBusinessService';


interface Props {
    businessNameId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const BusinessNameSwitchChange = ({ businessNameId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeBusinessName, fetchingActiveBusinessName } = useBusinessNamesService();

    const active = (value: boolean) => {
        setChecked(value);

        activeBusinessName(businessNameId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={businessNameId} callback={active} />;
};

export default BusinessNameSwitchChange;
